export type AppSystem = 'decision' | 'production';
export type AppStatus = 'beta' | 'alpha' | 'stable' | 'coming-soon';

export interface AppData {
  id: string;
  name: string;
  nameBold: string;
  subtitle: string;
  description: string;
  system: AppSystem;
  status: AppStatus;
  version?: string;
  isFree: boolean;
  iconSrc: string;
  launchUrl?: string;
}

const ICON_BASE = '/src/assets/';

export const DECISION_APPS: AppData[] = [
  {
    id: 'mockgen',
    name: 'Mock',
    nameBold: 'Gen',
    subtitle: 'AI Vehicle Mockup Generator',
    description: 'Upload your design panels and car photo. Get 5 professional mockup views in seconds. For wrap designers and studios presenting to clients.',
    system: 'decision',
    status: 'beta',
    version: 'v0.7',
    isFree: true,
    iconSrc: ICON_BASE + 'icon-visualizer.svg',
    launchUrl: 'https://mockupgen.forma.frankriccidesign.com',
  },
  {
    id: 'stylefinder',
    name: 'Style',
    nameBold: 'Finder',
    subtitle: 'AI Wrap Concept Generator',
    description: '3 reference images plus your car photo gives you an original design inspired by your vision. For car enthusiasts who know what they like but can\'t draw it.',
    system: 'decision',
    status: 'beta',
    version: 'v0.5',
    isFree: true,
    iconSrc: ICON_BASE + 'icon-variations.svg',
  },
  {
    id: 'reframe',
    name: 'Re',
    nameBold: 'frame',
    subtitle: 'AI Format Expander',
    description: 'One image in, every standard format out. AI expands and adapts the context automatically. For any creative who works across platforms and formats.',
    system: 'decision',
    status: 'coming-soon',
    isFree: true,
    iconSrc: ICON_BASE + 'icon-reconstructor.svg',
  },
  {
    id: 'swap',
    name: 'Swap',
    nameBold: 'Engine',
    subtitle: 'Vehicle Panel Swap Tool',
    description: 'Apply any graphic design to any vehicle in seconds. 7-panel mapping, automatic fitting and smart completion.',
    system: 'decision',
    status: 'coming-soon',
    isFree: false,
    iconSrc: ICON_BASE + 'icon-swap.svg',
  },
  {
    id: 'motion',
    name: 'Wrap',
    nameBold: 'Motion',
    subtitle: 'Animated Wrap Preview',
    description: 'Turn your static mockup into a cinematic reveal video. Motion design, automotive grade.',
    system: 'decision',
    status: 'coming-soon',
    isFree: false,
    iconSrc: ICON_BASE + 'icon-motion.svg',
  },
  {
    id: 'reportizer',
    name: 'Graphic Vision',
    nameBold: 'Reportizer',
    subtitle: 'Design Analysis Report',
    description: 'Upload a design board. Get a full breakdown: palette, layers, style, density, and junior advice.',
    system: 'decision',
    status: 'coming-soon',
    isFree: false,
    iconSrc: ICON_BASE + 'icon-reportizer.svg',
  },
];

export const PRODUCTION_APPS: AppData[] = [
  {
    id: 'modifier',
    name: 'Quick',
    nameBold: 'Panel Modifier',
    subtitle: 'Precision Panel Editor',
    description: 'Edit specific layers of an existing design - background, graphics, illustrations, branding - without touching the rest.',
    system: 'production',
    status: 'coming-soon',
    isFree: false,
    iconSrc: ICON_BASE + 'icon-modifier.svg',
  },
  {
    id: 'unwrap',
    name: '',
    nameBold: 'Unwrap',
    subtitle: 'Mockup-to-Print Extractor',
    description: 'Upload a wrapped car mockup. Get the flat 2D graphic extracted, reconstructed, and print-ready at 150 DPI.',
    system: 'production',
    status: 'coming-soon',
    isFree: false,
    iconSrc: ICON_BASE + 'icon-unwrap.svg',
  },
  {
    id: 'layout',
    name: 'Wrap',
    nameBold: 'Panel Layout',
    subtitle: 'Panel Calculator + Layout',
    description: 'Define your vehicle. Get the exact panel layout with real dimensions, bleeds, and splicing points.',
    system: 'production',
    status: 'coming-soon',
    isFree: false,
    iconSrc: ICON_BASE + 'icon-layout.svg',
  },
  {
    id: 'panelizer',
    name: '',
    nameBold: 'Panelizer',
    subtitle: 'Print Panel Generator',
    description: 'Enter the vehicle model. Get precise print panels with 20cm bleed, unified side panel, and splicing rules applied.',
    system: 'production',
    status: 'coming-soon',
    isFree: false,
    iconSrc: ICON_BASE + 'icon-panelizer.svg',
  },
  {
    id: 'zipchat',
    name: 'ZipChat-to-',
    nameBold: 'Report',
    subtitle: 'Chat-to-Brief Converter',
    description: 'Upload a client conversation. Get a structured design brief with 3 concept directions ready to present.',
    system: 'production',
    status: 'coming-soon',
    isFree: false,
    iconSrc: ICON_BASE + 'icon-zipchat.svg',
  },
];

export const ALL_APPS = [...DECISION_APPS, ...PRODUCTION_APPS];
